import { forwardRef } from 'react';
import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';
import { OnboardingPdfReport } from './OnboardingPdfReport';
import { OnboardingPdfReportV2 } from './OnboardingPdfReportV2';

export const OnboardingPdfReportContainer = forwardRef<HTMLDivElement>((_, ref) => {
  const { flags } = useFeatureFlags();

  if (flags.newReportPdfDesign === true) {
    return <OnboardingPdfReportV2 ref={ref} />;
  }

  return <OnboardingPdfReport ref={ref} />;
});

OnboardingPdfReportContainer.displayName = 'OnboardingPdfReportContainer';

export { OnboardingPdfReportContainer as OnboardingPdfReport };
